import React, { useEffect, useRef, useState } from 'react';

import { View } from 'react-native';

import RNBootSplash from 'react-native-bootsplash';
import Animated, {
    Easing,
    ReduceMotion,
    runOnJS,
    useAnimatedStyle,
    useSharedValue,
    withTiming,
} from 'react-native-reanimated';
import { useSelector } from 'react-redux';

import LottieView from 'lottie-react-native';

import LottieSplashAnimation from 'assets/lottie_splash_screen.json';

import { selectSplashScreenState } from 'store/config/selectors.ts';

import { isWeb } from 'utils/responsiveness.ts';

import styles from './styles.ts';

function SplashView() {
    const { visible } = useSelector(selectSplashScreenState);

    const lottieRef = useRef<LottieView>(null);

    const opacity = useSharedValue(1);

    const [animationFinished, setAnimationFinished] = useState(false);
    const [animationDone, setAnimationDone] = useState(false);

    const animatedStyle = useAnimatedStyle(() => ({
        opacity: opacity.value,
    }));

    const handleStartAnimation = async () => {
        await RNBootSplash.hide({ fade: true });
        lottieRef.current?.play();
    };

    const handleAnimationFinished = () => {
        setTimeout(() => {
            setAnimationFinished(true);
        }, 200);
    };

    useEffect(() => {
        if (!isWeb) {
            handleStartAnimation();
        }
    }, []);

    useEffect(() => {
        if (animationFinished) {
            opacity.value = withTiming(
                0,
                {
                    duration: 400,
                    easing: Easing.cubic,
                    reduceMotion: ReduceMotion.Never,
                },
                () => {
                    runOnJS(setAnimationDone)(true);
                },
            );
        }
    }, [animationFinished]);

    if (!visible && animationDone) {
        return null;
    }

    if (isWeb) {
        return (
            <Animated.View style={[styles.root, animatedStyle]}>
                <View style={styles.lottieAnimatedView}>
                    <LottieView
                        ref={lottieRef}
                        source={LottieSplashAnimation}
                        autoPlay={false}
                        loop={false}
                        onAnimationLoaded={handleStartAnimation}
                        onAnimationFinish={handleAnimationFinished}
                        onAnimationFailure={handleAnimationFinished}
                    />
                </View>
            </Animated.View>
        );
    }

    return (
        <Animated.View style={[styles.root, animatedStyle]}>
            <LottieView
                ref={lottieRef}
                style={styles.lottieAnimatedView}
                source={LottieSplashAnimation}
                autoPlay={false}
                loop={false}
                onAnimationFinish={handleAnimationFinished}
                onAnimationFailure={handleAnimationFinished}
            />
        </Animated.View>
    );
}

export default SplashView;
